import * as React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { GetEvaluationAgreementsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import type QuestionGroup from 'modules/reviews/store/models/QuestionGroup'

import NoAgreementsYet from './Banners/NoAgreementsYet'
import TargetAgreeEvaluation from './Banners/TargetAgreeEvaluation'
import TargetDisagreeEvaluation from './Banners/TargetDisagreeEvaluation'

interface Props {
  questionGroup: QuestionGroup
}

const AgreementOnEvaluationSection = ({ questionGroup }: Props) => {
  const { access } = useCurrentSession()
  const currentUserIsTarget = access.id === questionGroup.target.id
  const currentUserIsReviewer =
    questionGroup.respondent && access.id === questionGroup.respondent.id

  const { data, loading } = useQuery(GetEvaluationAgreementsDocument, {
    variables: { evaluation_id: Number(questionGroup.id) },
  })

  if (loading)
    return (
      <Box width="full" alignItems="center" height="full" justifyContent="center">
        <Spinner />
      </Box>
    )
  if (!currentUserIsTarget && !currentUserIsReviewer) return null

  const lastAgreement = data?.performanceReviews.evaluationAgreementsConnection.edges.at(0)

  return (
    <>
      {lastAgreement?.node ? (
        lastAgreement.node.agree ? (
          <TargetAgreeEvaluation
            questionGroup={questionGroup}
            agreement={lastAgreement.node}
            canEditAgreement={currentUserIsTarget}
          />
        ) : (
          <TargetDisagreeEvaluation
            questionGroup={questionGroup}
            agreement={lastAgreement.node}
            canEditAgreement={currentUserIsTarget}
          />
        )
      ) : (
        <NoAgreementsYet questionGroup={questionGroup} canEditAgreement={currentUserIsTarget} />
      )}
    </>
  )
}

export default AgreementOnEvaluationSection
